import { TorchWeeklyTdrWarReport } from '../models';
import { ManyResponse } from '../../../responses';
import {Injectable} from '@angular/core';
import {Burly} from 'kb-burly';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';
import {Cacheable} from 'ts-cacheable';

@Injectable({
  providedIn: 'root'
})
export class TorchTdrMetricsService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  @Cacheable()
  getMaxWarReportDate(): Observable<string> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/war-report')
      .addSegment('/maxWarReportMonth')
      .get;

    return this.httpClient.get<{ WAR_REPORT_DATE: string }>(endpointURL).pipe(
      map(response => response.WAR_REPORT_DATE),
      distinctUntilChanged()
    );
  }

  @Cacheable()
  getLatestWarReport(): Observable<TorchWeeklyTdrWarReport[]> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/war-report')
      .addSegment('/latestWarReport')
      .get;

    return this.httpClient.get<ManyResponse<TorchWeeklyTdrWarReport>>(endpointURL).pipe(
      map(response => response.data),
      distinctUntilChanged()
    );
  }

  @Cacheable()
  getSpecificTdr(date: string, fleet: string, type: string): Observable<number> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/war-report')
      .addSegment(`/tdr-value/date/${date}/fleet/${fleet}/type/${type}`)
      .get;

    return this.httpClient.get<number>(endpointURL).pipe(
      distinctUntilChanged()
    );
  }

  @Cacheable()
  getLatestFleetFytdTdr(): Observable<number> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/war-report')
      .addSegment('/latestFleetFytdTdr')
      .get;

    return this.httpClient.get<number>(endpointURL).pipe(
      distinctUntilChanged()
    );
  }

  @Cacheable()
  getLatestFleetFytdTdrTarget(): Observable<number> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/war-report')
      .addSegment('/latestFleetFytdTdrTarget')
      .get;

    return this.httpClient.get<number>(endpointURL).pipe(
      distinctUntilChanged()
    );
  }

  @Cacheable()
  getLatestAllFleetsFytdReport(): Observable<TorchWeeklyTdrWarReport[]> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tdr/war-report')
      .addSegment('/latestAllFleetsFytdReport')
      .get;

    return this.httpClient.get<TorchWeeklyTdrWarReport[]>(endpointURL).pipe(
      map(response => response.filter(rpt => rpt.fleetCode !== 'FLEET')),
      distinctUntilChanged()
    );
  }
}
